import React from 'react';
import SignInModal from "./SignInModal/SignInModal.tsx";
import Settings from "./Settings/Settings.tsx";
import LoadingChatDots from "./LoadingChatDots/LoadingChatDots.tsx";
import SharePopup from "./SharePopup/SharePopup.tsx";
import AskToSave from "./AskToSave/AskToSave.tsx";
import AppsNotification from "./AppsNotification/AppsNotification.tsx";
import {useAppStore} from "../../GlobalStore/GlobalStore.ts";
import ErrorPopup from "./ErrorPopup/ErrorPopup.tsx";
import EnlargedContent from "./EnlargedContent/EnlargedContent.tsx";
import ModelConfigPopup from "./ModelConfigPopup/ModelConfigPopup.tsx";
import ReportPopup from "./ReportPopup/ReportPopup.tsx";
import UpdateUI from './UpdateUI/UpdateUI.tsx';
import FileSearchPopup from './FileSearchPopup/FileSearchPopup.tsx';
import OverdueFees from './OverdueFees/OverdueFees.tsx';
import ApiKeyModeWarning from './ApiKeyModeWarning/ApiKeyModeWarning.tsx';
import UpgradeFeatureBreakdown from './UpgradeFeatureBreakdown/UpgradeFeatureBreakdown.tsx';
import NoEmbeddingsPrompt from './NoEmbeddingsPrompt/NoEmbeddingsPrompt.tsx';
import NoEmbeddingsInstructions from './NoEmbeddingsInstructions/NoEmbeddingsInstructions.tsx';
import IntroMessage from './IntroMessage/IntroMessage.tsx';
import DowngradeMessage from './DowngradeMessage/DowngradeMessage.tsx';
import SignedOutPopup from './SignedOutPopup/SignedOutPopup.tsx';
interface MiddlePopupProps {}

const MiddlePopup: React.FC<MiddlePopupProps> = () => {
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { visiblePopup } = dynamicStateObj;
    const [isAnimating, setIsAnimating] = React.useState(false);

    // Handle animation state
    React.useEffect(() => {
        if (visiblePopup) {
            setIsAnimating(true);
        } else {
            setIsAnimating(false);
        }
    }, [visiblePopup]);

    const getPopupComponent = (): React.ReactNode => {
        if (!visiblePopup) return null;

        if (visiblePopup === "signin") {
            return <SignInModal />
        } else if (visiblePopup === "settings" || visiblePopup.startsWith("settings:")) {
            const defaultTab = visiblePopup.includes(":") ? visiblePopup.split(":")[1] : undefined;
            return <Settings defaultActiveTab={defaultTab} />
        } else if (visiblePopup === "share") {
            return <SharePopup />;
        } else if (visiblePopup === "askToSave") {
            return <AskToSave />
        } else if (visiblePopup === "error") {
            return <ErrorPopup />
        } else if (visiblePopup === "enlargedContent") {
            return <EnlargedContent />
        } else if (visiblePopup === "appsNotification") {
            return <AppsNotification />
        } else if (visiblePopup.startsWith("modelConfig")) {
            const modelName = visiblePopup.split(":")[1];
            return <ModelConfigPopup modelName={modelName} />;
        } else if (visiblePopup === "report") {
            return <ReportPopup />;
        } else if (visiblePopup === "loadingChatDots") {
            return <LoadingChatDots />;
        } else if (visiblePopup === "updateUi") {
            return <UpdateUI />;
        } else if (visiblePopup === "fileSearch") {
            return <FileSearchPopup />;
        } else if (visiblePopup === "owesOverdueFees") {
            return <OverdueFees />;
        } else if (visiblePopup === "apiKeyModeWarning") {
            return <ApiKeyModeWarning />;
        } else if (visiblePopup === "upgradeFeatureBreakdown") {
            return <UpgradeFeatureBreakdown />;
        } else if (visiblePopup === "noEmbeddingsPrompt") {
            return <NoEmbeddingsPrompt />;
        } else if (visiblePopup === "noEmbeddingsInstructions") {
            return <NoEmbeddingsInstructions />;
        } else if (visiblePopup === "introMessage") {
            return <IntroMessage />;
        } else if (visiblePopup === "downgradeMessage") {
            return <DowngradeMessage />;
        } else if (visiblePopup === "signedOut") {
            return <SignedOutPopup />;
        }
        return null;
    };

    const popupComponent = getPopupComponent();

    return (
        <div className={`fixed inset-0 flex items-center justify-center transition-opacity duration-300 ${isAnimating ? 'opacity-100' : 'opacity-0 pointer-events-none'} z-50`}>
            {popupComponent}
        </div>
    );
};

export default MiddlePopup;